<template>
    <div class="flex flex-col h-screen w-screen">
        <header class="bg-primary h-14 w-full text-white flex items-center px-5">
            <img src="/images/yoto-logo.png" alt="Yoto Logo" class="h-7" >
        </header>
        <slot/>
    </div>
</template>